import { applySnapshot, types, flow } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import systemHelperAPI from "../systemhelper/SystemHelperService";
import { ErrorModel } from "../../components/common/error";
import SDGsAPI from "./SDGsService";
import { PaginationModel } from "../share/PagingModel";
import { SDGDetailModel } from "../share/SDGDetailModel";

export const FilterSummarySdg = types
  .model("FilterSummarySdg", {
    fiscalYear: customtypes.optional(types.number, 0),
    organizeId: customtypes.optional(types.number, 0),
    sectorId: customtypes.optional(types.number, 0),
    isProject: types.optional(types.boolean, false),
    isFiveYearPlan: types.optional(types.boolean, false),
    typeReport: customtypes.optional(types.string, ""),
    sdgType: customtypes.optional(types.number, 0),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    resetAll: () => {
      applySnapshot(self, {});
    },
    onClearFilter: () => {
      self.setField({
        fieldname: "isProject",
        value: true,
      });
      self.setField({
        fieldname: "organizeId",
        value: 0,
      });
      self.setField({
        fieldname: "fiscalYear",
        value: null,
      });
      self.setField({
        fieldname: "sectorId",
        value: 0,
      });
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IFilterSummarySdg = typeof FilterSummarySdg.Type;

export const SummaryListSdgModel = types
  .model("SummaryListSdgModel", {
    sdgKey: customtypes.optional(types.number, 0),
    name: customtypes.optional(types.string, ""),
    code: customtypes.optional(types.string, ""),
    description: customtypes.optional(types.string, ""),
    topic: customtypes.optional(types.string, ""),
    sumThbAmount: customtypes.optional(types.number, 0),
    percentile: customtypes.optional(types.number, 0),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    resetAll: () => {
      applySnapshot(self, {});
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
  }));
export type ISummaryListSdgModel = typeof SummaryListSdgModel.Type;

export const SummaryListSectorSdgModel = types
  .model("SummaryListSectorSdgModel", {
    sdgKey: customtypes.optional(types.number, 0),
    name: customtypes.optional(types.string, ""),
    code: customtypes.optional(types.string, ""),
    description: customtypes.optional(types.string, ""),
    topic: customtypes.optional(types.string, ""),
    sumThbAmount: customtypes.optional(types.number, 0),
    percentile: customtypes.optional(types.number, 0),
    sector1_SumThbAmount: customtypes.optional(types.number, 0),
    sector1_Percentile: customtypes.optional(types.number, 0),
    sector2_SumThbAmount: customtypes.optional(types.number, 0),
    sector2_Percentile: customtypes.optional(types.number, 0),
    sector3_SumThbAmount: customtypes.optional(types.number, 0),
    sector3_Percentile: customtypes.optional(types.number, 0),
    sector4_SumThbAmount: customtypes.optional(types.number, 0),
    sector4_Percentile: customtypes.optional(types.number, 0),
    sector5_SumThbAmount: customtypes.optional(types.number, 0),
    sector5_Percentile: customtypes.optional(types.number, 0),
    sector6_SumThbAmount: customtypes.optional(types.number, 0),
    sector6_Percentile: customtypes.optional(types.number, 0),
    sector7_SumThbAmount: customtypes.optional(types.number, 0),
    sector7_Percentile: customtypes.optional(types.number, 0),
    sector8_SumThbAmount: customtypes.optional(types.number, 0),
    sector8_Percentile: customtypes.optional(types.number, 0),
    sector9_SumThbAmount: customtypes.optional(types.number, 0),
    sector9_Percentile: customtypes.optional(types.number, 0),
    sector10_SumThbAmount: customtypes.optional(types.number, 0),
    sector10_Percentile: customtypes.optional(types.number, 0),
    sector11_SumThbAmount: customtypes.optional(types.number, 0),
    sector11_Percentile: customtypes.optional(types.number, 0),
    sector12_SumThbAmount: customtypes.optional(types.number, 0),
    sector12_Percentile: customtypes.optional(types.number, 0),
    sector13_SumThbAmount: customtypes.optional(types.number, 0),
    sector13_Percentile: customtypes.optional(types.number, 0),
    sector14_SumThbAmount: customtypes.optional(types.number, 0),
    sector14_Percentile: customtypes.optional(types.number, 0),
    sector15_SumThbAmount: customtypes.optional(types.number, 0),
    sector15_Percentile: customtypes.optional(types.number, 0),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    resetAll: () => {
      applySnapshot(self, {});
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
  }));
export type ISummaryListSectorSdgModel = typeof SummaryListSectorSdgModel.Type;

const OrganizeSummaryModel = types
  .model("OrganizeSummaryModel", {
    organizationID: customtypes.optional(types.number, 0),
    organizationTHName: customtypes.optional(types.string, ""),
    sumThbAmount: customtypes.optional(types.number, 0),
    sumPercentile: customtypes.optional(types.number, 0),
    sdg01_ThbAmount: customtypes.optional(types.number, 0),
    sdg01_Percentile: customtypes.optional(types.number, 0),
    sdg02_ThbAmount: customtypes.optional(types.number, 0),
    sdg02_Percentile: customtypes.optional(types.number, 0),
    sdg03_ThbAmount: customtypes.optional(types.number, 0),
    sdg03_Percentile: customtypes.optional(types.number, 0),
    sdg04_ThbAmount: customtypes.optional(types.number, 0),
    sdg04_Percentile: customtypes.optional(types.number, 0),
    sdg05_ThbAmount: customtypes.optional(types.number, 0),
    sdg05_Percentile: customtypes.optional(types.number, 0),
    sdg06_ThbAmount: customtypes.optional(types.number, 0),
    sdg06_Percentile: customtypes.optional(types.number, 0),
    sdg07_ThbAmount: customtypes.optional(types.number, 0),
    sdg07_Percentile: customtypes.optional(types.number, 0),
    sdg08_ThbAmount: customtypes.optional(types.number, 0),
    sdg08_Percentile: customtypes.optional(types.number, 0),
    sdg09_ThbAmount: customtypes.optional(types.number, 0),
    sdg09_Percentile: customtypes.optional(types.number, 0),
    sdg10_ThbAmount: customtypes.optional(types.number, 0),
    sdg10_Percentile: customtypes.optional(types.number, 0),
    sdg11_ThbAmount: customtypes.optional(types.number, 0),
    sdg11_Percentile: customtypes.optional(types.number, 0),
    sdg12_ThbAmount: customtypes.optional(types.number, 0),
    sdg12_Percentile: customtypes.optional(types.number, 0),
    sdg13_ThbAmount: customtypes.optional(types.number, 0),
    sdg13_Percentile: customtypes.optional(types.number, 0),
    sdg14_ThbAmount: customtypes.optional(types.number, 0),
    sdg14_Percentile: customtypes.optional(types.number, 0),
    sdg15_ThbAmount: customtypes.optional(types.number, 0),
    sdg15_Percentile: customtypes.optional(types.number, 0),
    sdg16_ThbAmount: customtypes.optional(types.number, 0),
    sdg16_Percentile: customtypes.optional(types.number, 0),
    sdg17_ThbAmount: customtypes.optional(types.number, 0),
    sdg17_Percentile: customtypes.optional(types.number, 0),
    error: types.optional(ErrorModel, {}),
  })
    .views((self: any) => ({
          
      }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
     limitAmountAsMillionBaht(val:number) {
      if(val==undefined || val==0)
        return 0;
      else
       return val / 1000000;
  },
  }));
export type IOrganizeSummaryModel = typeof OrganizeSummaryModel.Type;
export const OrganizeListSDGModel = types
  .model("OrganizeListSDGModel", {
    orgTypeCode: types.optional(types.string, ""),
    list: types.optional(types.array(OrganizeSummaryModel), []),
    paging: types.optional(PaginationModel, {
      pageSize: 10,
    }),
    error: types.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setOrgTypeCode: (orgTypeCode: string) => {
      self.orgTypeCode = orgTypeCode;
    },
    onSelectedFilter: (value: any) => {
      self.setDefaultPagination();
      self.orgTypeCode = value;
      // self.getOrganizeList();
    },
    onSearchTextFilter: (value: any) => {
      self.setDefaultPagination();
      self.paging.searchText = value;
      // self.getOrganizeList();
    },
    onSelectedPage: (pageNo: number) => {
      self.paging.pageNo = pageNo;
      // self.getOrganizeList();
    },
    setPagination: (result: any) => {
      self.paging.pageSize = result.pageSize;
      self.paging.pageNo = result.pageNo;
      self.paging.totalRow = result.totalRow;
    },
    setDefaultPagination: () => {
      self.paging.pageNo = 1;
    },
    resetAll: () => {
      self.list = [];
      self.paging = {
        pageSize: 10,
      };
    },
  }));

export type IOrganizeListSDGModel = typeof OrganizeListSDGModel.Type;
export const SdgSummarySdgModel = types
  .model("SdgSummarySdgModel", {
    sumThbAmount: customtypes.optional(types.number, 0),
    sumPercent: customtypes.optional(types.number, 0),
    expenseSummary: customtypes.optional(types.number, 0),
    summaryListSdg: customtypes.optional(types.array(SummaryListSdgModel), []),
    SummaryListSectorSdg: customtypes.optional(types.array(SummaryListSectorSdgModel), []),
    organizeListSdg: customtypes.optional(OrganizeListSDGModel, {}),
    dateTimeAt: customtypes.optional(types.string, ""),
    error: customtypes.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    resetAll: () => {
      applySnapshot(self, {});
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
    GetSummarySdg: flow(function* (filter: IFilterSummarySdg) {
      try {
        self.loading = true;
        self.sumThbAmount=0;
        self.sumPercent=0;
        self.expenseSummary=0;
        self.summaryListSdg =[];
        self.SummaryListSectorSdg =[];
        self.organizeListSdg.list=[];
        var result=yield SDGsAPI.GetSummarySdg(filter);
        self.setAllField(result.data);
        try{
          var resultListPercent=yield SDGsAPI.GetSummaryListSdg(filter);
          self.summaryListSdg=resultListPercent.data;
        }catch (e) {
          console.log('error GetSummarySdg ',e)
          
        }

        try{
          var resultListSector=yield SDGsAPI.GetSummaryListSectorSdg(filter);
          self.SummaryListSectorSdg=resultListSector.data;
        }catch (e) {
          console.log('error GetSummaryListSectorSdg ',e)
          
        }

        try{
          const resultListOrg = yield SDGsAPI.GetSummaryListOrganizationSdg(filter);
          console.log('resultListOrg ',resultListOrg)
          self.organizeListSdg.list = resultListOrg.data;
          // self.organizeListSdg.setPagination(resultListOrg);
        }catch (e) {
          console.log('error GetSummaryListOrganizationSdg ',e)
          
        }
        self.loading = false;
      } catch (e) {
        console.log('error GetSummarySdg ',e)
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    GetPrintSummaryListSdg: flow(function* (filter: IFilterSummarySdg) {
      try {
        yield SDGsAPI.printSummarySdgs(filter);
      } catch (e) {
        console.log('error GetSummarySdg ',e)
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    GetPrintSummaryListSectorSdg: flow(function* (filter: IFilterSummarySdg) {
      try {
        yield SDGsAPI.printSummarySectorSdgs(filter);
      } catch (e) {
        console.log('error GetSummarySectorSdg ',e)
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    GetPrintSummaryListOrganizationSdg: flow(function* (filter: IFilterSummarySdg) {
      try {
        yield SDGsAPI.printSummaryListOrganizationSdg(filter);
      } catch (e) {
        console.log('error GetPrintSummaryListOrganizationSdg ',e)
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
  }));
export type ISdgSummarySdgModel = typeof SdgSummarySdgModel.Type;
